const SVGFinancialReview = () => (
  <svg
    width="130"
    height="59"
    viewBox="0 0 130 59"
    fill="none"
    style={{ width: '100%' }}
    xmlns="http://www.w3.org/2000/svg"
    role="img"
  >
    <title>Financial Review Logo</title>
    <g clipPath="url(#clip0_1732_12213)">
      <g clipPath="url(#clip1_1732_12213)">
        <path
          d="M113.676 27.7681L113.681 27.0157H115.933V4.6368H113.731L113.737 3.90045H122.528L122.536 4.6368H119.94V27.0157C119.94 27.0157 122.154 27.0082 123.08 27.0157C124.141 26.8123 124.89 25.8149 125.268 24.8911C125.541 23.9405 125.55 22.7758 125.532 21.7696L126.309 21.7757C126.293 23.7346 126.325 25.8095 126.309 27.7681H113.676Z"
          fill="#0E88D3"
        />
        <path
          d="M103.378 18.7506L105.384 18.7605L102.87 7.40036L101.003 18.7547L103.378 18.7506ZM104.784 27.7678L104.785 27.0206L107.116 27.0155L105.61 19.701H100.835L99.5656 27.0155H101.78L101.78 27.7678H96.6525L96.658 27.0155H98.5842L102.618 3.90021H106.377L111.438 27.0155H112.857V27.7678H104.784V27.7678Z"
          fill="#0E88D3"
        />
        <path
          d="M87.3047 27.7681L87.3064 27.0157H89.5226L89.5233 4.6368H87.4451L87.4447 3.90045H95.9266L95.9392 4.6368H93.7809L93.7789 27.0157H95.8339L95.8285 27.7681H87.3047Z"
          fill="#0E88D3"
        />
        <path
          d="M85.8134 27.7678H85.1588C85.0569 27.2638 85.1148 26.7657 84.6671 26.4706C83.9784 26.5179 83.6271 27.4151 82.9903 27.5954C81.4985 28.7215 79.3603 27.9361 77.9101 27.2359C73.2238 24.0479 72.4224 18.3758 72.943 12.9797C73.2623 9.51432 75.2747 6.16853 78.4934 4.31486C79.823 3.55807 81.9162 3.31034 83.3133 4.08929C83.895 4.20003 84.2061 4.97012 84.8961 4.81713C85.1625 4.58099 85.1653 4.24808 85.1676 3.90393H85.8038L85.8045 10.5829L85.0344 10.5894C84.8657 8.52275 84.9635 6.2469 83.041 4.98716C82.0396 4.44946 80.4793 4.27806 79.5457 5.09109C78.0784 6.50893 77.5336 8.54013 77.2194 10.5822C76.6708 14.1522 76.6882 16.3303 77.1287 20.7545C77.3131 22.7411 78.1186 25.1549 79.3555 26.6021C79.9385 27.2233 81.5094 27.3453 82.3071 26.9541C85.0085 25.2623 84.6797 23.624 84.9434 21.7604L85.8157 21.7679L85.8134 27.7678Z"
          fill="#0E88D3"
        />
        <path
          d="M72.9889 4.63644H70.9188L70.9263 27.7677H68.276L60.5012 8.03811L60.5056 27.0153H62.6434L62.6383 27.7677H57.3087V27.0153H59.4847V4.63644H57.4304L57.4307 3.90008H63.2605L69.9075 20.5643L69.9 4.63644H68.0412L68.0463 3.90008H72.997L72.9889 4.63644Z"
          fill="#0E88D3"
        />
        <path
          d="M49.4553 18.6936L47.1461 8.10015L45.3609 18.7022L49.4553 18.6936ZM49.0103 27.7681V27.0157H51.2419L49.641 19.537L45.2049 19.539L43.9311 27.0157H46.284L46.2935 27.7681H40.6641L40.6699 27.0157H42.8247L46.9461 3.90045H50.7583L55.644 27.0157H56.7388L56.733 27.7681H49.0103V27.7681Z"
          fill="#0E88D3"
        />
        <path
          d="M41.8598 4.63631H39.8055L39.8109 27.7676H36.6979L29.365 8.49186L29.3561 27.0152H31.6078L31.6115 27.7676H26.1289L26.1381 27.0152H28.3496L28.3332 4.63631H26.223L26.2189 3.89996H32.1513L38.8251 21.0746L38.8292 4.63631H36.7602L36.7657 3.89996H41.8639L41.8598 4.63631Z"
          fill="#0E88D3"
        />
        <path
          d="M25.0995 3.90045L25.0992 4.6368H22.9266L22.9395 27.0157H25.2212V27.7681H16.0898L16.095 27.0157H18.8952C18.8952 27.0157 18.8898 5.29854 18.8952 4.6368H16.4728L16.4691 3.90045H25.0995Z"
          fill="#0E88D3"
        />
        <path
          d="M15.8043 10.4166H15.2008C15.0022 8.74733 15.054 6.96079 13.8198 5.7065C12.8599 4.68017 10.7333 4.58783 9.38359 4.55035V14.6913L11.534 14.6808C12.6118 14.6903 12.898 12.3429 12.8548 11.1513L13.6934 11.1489V18.5305H12.8742C12.8837 17.3658 12.6946 15.3834 11.5497 15.3929H9.38359V27.0155H12.0213V27.7678H2.24494L2.25107 27.0155H5.33347L5.35016 4.63179L2.23438 4.63111L2.23949 3.90021H15.8043V10.4166Z"
          fill="#0E88D3"
        />
        <path
          d="M4.11809 25.5524H2.51692V26.0635H2.32031V24.816H2.51692V25.3268H4.11809V25.5524Z"
          fill="#0E88D3"
        />
        <path
          d="M4.11809 23.4564H3.26384V24.2899H4.11809V24.5151H2.32031V24.2899H3.06723V23.4564H2.32031V23.2315H4.11809V23.4564Z"
          fill="#0E88D3"
        />
        <path
          d="M4.11809 21.5575V22.7212H2.32031V21.5838H2.5142V22.4956H3.08563V21.7726H3.26623V22.4956H3.92421V21.5575H4.11809Z"
          fill="#0E88D3"
        />
        <path
          d="M2.56156 19.8654L3.42365 20.1431V19.5904L2.56156 19.8654ZM4.11809 19.3597L3.59402 19.5406V20.2061L4.11809 20.3659V20.5547L2.32031 19.9727V19.7137L4.11809 19.1293V19.3597Z"
          fill="#0E88D3"
        />
        <path
          d="M2.32031 17.6108H3.45738C3.63594 17.6108 3.80086 17.621 3.94499 17.742C4.08913 17.8623 4.14433 18.0432 4.14433 18.2265C4.14433 18.402 4.10753 18.5881 3.97123 18.7087C3.82471 18.8395 3.64343 18.8501 3.45738 18.8501H2.32031V18.6249H3.45738C3.56506 18.6249 3.71158 18.6225 3.80597 18.5564C3.91364 18.4835 3.94499 18.3315 3.94499 18.2081C3.94499 18.0926 3.90853 17.9618 3.81653 17.8858C3.71431 17.7992 3.58074 17.7992 3.45738 17.7992H2.32031V17.6108Z"
          fill="#0E88D3"
        />
        <path
          d="M3.58765 17.019C3.83639 16.9457 3.95191 16.7389 3.95191 16.4871C3.95191 16.3794 3.9284 16.2486 3.86297 16.1647C3.81016 16.0966 3.71884 16.0547 3.63229 16.0547C3.45135 16.0547 3.37809 16.2039 3.3389 16.3613L3.2653 16.6602C3.23668 16.7808 3.20772 16.8905 3.12117 16.9849C3.03734 17.0796 2.91399 17.1318 2.78826 17.1318C2.4424 17.1318 2.29315 16.8329 2.29315 16.5211C2.29315 16.2199 2.4424 15.9787 2.7334 15.8819L2.78826 16.0864C2.59199 16.1255 2.47136 16.3351 2.47136 16.5266C2.47136 16.697 2.5603 16.912 2.75691 16.912C2.95863 16.912 3.00327 16.7546 3.04245 16.5866L3.10822 16.3167C3.13412 16.1988 3.16853 16.0809 3.2469 15.9892C3.3389 15.8765 3.46191 15.8216 3.60332 15.8216C3.76586 15.8216 3.91272 15.8921 4.01222 16.0233C4.11172 16.1542 4.14307 16.33 4.14307 16.4925C4.14307 16.8592 3.98053 17.1001 3.63229 17.2207L3.58765 17.019Z"
          fill="#0E88D3"
        />
        <path
          d="M4.11809 15.1124H2.51692V15.6235H2.32031V14.3761H2.51692V14.8868H4.11809V15.1124Z"
          fill="#0E88D3"
        />
        <path
          d="M3.15616 13.4281C3.15616 13.3075 3.14833 13.208 3.05667 13.1191C2.99363 13.056 2.90742 13.0274 2.82087 13.0274C2.71592 13.0274 2.62971 13.0666 2.57178 13.1531C2.51692 13.2315 2.5142 13.3075 2.5142 13.4019V13.85H3.15616V13.4281ZM4.11809 13.0192L3.33983 13.3521V13.85H4.11809V14.0752H2.32031V13.4019C2.32031 13.2554 2.33871 13.1136 2.43037 12.9933C2.52203 12.8727 2.67162 12.8018 2.82325 12.8018C3.03554 12.8018 3.22704 12.9276 3.28463 13.1371L4.11809 12.7834V13.0192V13.0192Z"
          fill="#0E88D3"
        />
        <path
          d="M2.56156 11.8907L3.42365 12.1685V11.6158L2.56156 11.8907ZM4.11809 11.3851L3.59402 11.5657V12.2315L4.11809 12.3913V12.5801L2.32031 11.9981V11.7388L4.11809 11.1544V11.3851V11.3851Z"
          fill="#0E88D3"
        />
        <path
          d="M4.11809 9.80625V10.8677H2.32031V10.6421H3.91876V9.80625H4.11809Z"
          fill="#0E88D3"
        />
        <path d="M4.11809 9.49805H2.32031V9.27281H4.11809V9.49805Z" fill="#0E88D3" />
        <path
          d="M2.56156 8.27112L3.42365 8.54883V7.99614L2.56156 8.27112ZM4.11809 7.76545L3.59402 7.94605V8.61187L4.11809 8.77168V8.96045L2.32031 8.37845V8.11915L4.11809 7.53476V7.76545V7.76545Z"
          fill="#0E88D3"
        />
        <path
          d="M4.11809 6.14993L2.551 7.0645H4.11809V7.25293H2.32031V6.97011L3.78518 6.11858H2.32031V5.92981H4.11809V6.14993Z"
          fill="#0E88D3"
        />
      </g>
      <g clipPath="url(#clip2_1732_12213)">
        <path
          d="M105.302 49.1404L102.099 30.7574H99.8028L97.0353 49.6263L94.4354 31.4795H97.0094L97.0057 30.7574H88.6836L88.6846 31.4795H90.4606L94.0851 54.669L97.0758 54.6622L99.6062 39.9866L102.387 54.6714L105.331 54.6646L109.092 31.4795H111.434L111.434 30.7574H105.768L105.764 31.4795H108.085L105.302 49.1404Z"
          fill="#0E88D3"
        />
        <path
          d="M75.7139 54.6509L75.7146 53.8862L78.0164 53.8822V31.4791L75.5749 31.4774L75.5742 30.7574H87.945L87.9324 36.1589L87.3266 36.1599C87.1024 34.4374 86.9971 32.4768 85.2041 31.6416C84.4374 31.5029 82.1258 31.5574 82.1258 31.5574L82.1292 41.3825C82.1292 41.3825 83.8973 41.6401 84.5379 41.0363C85.2041 40.4857 85.5854 39.3363 85.5823 38.4804L86.21 38.4698V45.4879H85.631C85.4296 44.2687 85.3557 43.0365 84.5522 42.4211C84.0322 42.0852 82.1281 42.1659 82.1281 42.1659L82.1145 53.8634C82.1145 53.8634 83.7712 53.8423 84.513 53.7421C85.415 53.5377 86.3463 52.7516 86.7238 51.9334C87.1 50.795 87.2496 48.3109 87.2496 48.3109L87.8663 48.3157L87.8697 54.6509H75.7139Z"
          fill="#0E88D3"
        />
        <path
          d="M74.2559 54.6514H65.543L65.5352 53.882H67.9401L67.9378 31.4922H65.9369V30.7572H74.1322V31.4922H71.8121L71.8063 53.882H74.2559V54.6514Z"
          fill="#0E88D3"
        />
        <path
          d="M64.1136 31.4924L59.8502 54.6329L55.9054 54.6353L51.3755 31.4924H50.1992V30.7574H57.8926V31.4924H55.7292C55.7292 31.4924 59.381 52.3969 59.4341 52.3976L63.1002 31.4924H61.0476V30.7574H65.3093V31.4924H64.1136Z"
          fill="#0E88D3"
        />
        <path
          d="M37.4783 54.6673L37.4844 53.9173H39.1831V31.4788L37.3015 31.474L37.3008 30.7571H49.321V36.5096H48.6913C48.5741 34.6821 48.4589 32.5514 46.6124 31.7156C45.8471 31.4185 44.1178 31.5616 43.2972 31.5551L43.3058 41.6361C43.3058 41.6361 45.3107 41.799 45.8961 41.4064C46.8816 40.6997 47.0056 39.396 47.0649 38.3108L47.7235 38.3165L47.7212 45.5649L47.1354 45.5656C47.0121 44.4261 46.7429 43.2843 45.9316 42.6968C45.3489 42.4372 43.2976 42.4352 43.2976 42.4352L43.3126 53.9173C44.7989 53.936 47.8892 53.8052 48.7519 51.8527C49.0784 50.7967 49.1417 49.737 49.1506 48.4415L49.8222 48.448L49.8147 54.668L37.4783 54.6673Z"
          fill="#0E88D3"
        />
        <path
          d="M29.8315 38.8789C29.9563 36.5505 30.1133 33.5145 28.38 31.806C27.8508 31.4782 26.2915 31.4754 25.577 31.4962V41.6573C25.577 41.6573 27.6106 41.7732 28.2212 41.5397C29.284 41.1247 29.638 39.91 29.8315 38.8789ZM36.8973 53.9147V54.6527H31.6689C31.3809 54.2268 31.4477 53.7729 31.3612 53.2659C31.1475 52.0119 30.1137 45.4764 28.9511 43.6272C28.5006 42.8707 27.0667 42.4993 26.0878 42.4386L25.577 42.4478V53.8932H27.7567V54.6527H18.9338V53.8932H21.4315L21.4372 31.4925L19.0984 31.487L19.112 30.7572H28.7752C30.6016 30.7987 32.1824 31.7446 33.2557 33.2623C34.3287 34.7534 34.1764 37.4211 33.4752 39.0039C32.4788 41.1138 30.3014 41.917 28.2345 42.1381C30.1127 42.3122 31.9854 43.1481 32.9248 44.8501C34.3314 47.694 34.6756 50.7607 35.7101 53.761C36.012 53.9791 36.8973 53.9147 36.8973 53.9147"
          fill="#0E88D3"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1732_12213">
        <rect
          width="128.56"
          height="57.2545"
          fill="white"
          transform="translate(0.859375 0.76123)"
        />
      </clipPath>
      <clipPath id="clip1_1732_12213">
        <rect
          width="128.56"
          height="30.2818"
          fill="white"
          transform="translate(0.859375 0.76123)"
        />
      </clipPath>
      <clipPath id="clip2_1732_12213">
        <rect
          width="99.3795"
          height="30.2818"
          fill="white"
          transform="translate(16.0938 27.7339)"
        />
      </clipPath>
    </defs>
  </svg>
);

// eslint-disable-next-line import/no-default-export
export default SVGFinancialReview;
